import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import Container from "@material-ui/core/Container";
import LocalNavMain from '../../components/LocalNavMain';
import { customMuiTheme, showFooter } from '../../common/utilities';
import { ThemeProvider } from '@material-ui/styles';
import clsx from 'clsx';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';



import styles from "./MainPageTemplate.module.scss";

export default function MainPageTemplate(props) {
  const { 
    title,
    children, 
    headerData,
    bannerAvatarData,
    premiumLogged,
    creator,
  } = props;

  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('xs')); 

  //scroll to top on componentDidMount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if(headerData)
  {
    document.title = title;
    showFooter();
  }

  return (
    <ThemeProvider theme={customMuiTheme}>
      <Header 
        headerData={headerData} 
        bannerAvatarData={bannerAvatarData}
        showBanner 
        creator={creator}
        mainPage
        premiumLogged={premiumLogged}
      />
      <LocalNavMain creator={creator} />
      <main className={clsx(
          styles.content,
          mobile && styles.mobile
        )}>
        {/* commented out for now - will look into it later
        want to focus on main page  */}
     
        {children}
      </main>
    </ThemeProvider>
  );
}
